let Components = {}

Components['SearchCarouselItemDefault'] = require('./SearchCarouselItemDefault').default;
Components['SearchCarouselItemGiodicart'] = require('./SearchCarouselItemGiodicart').default;

export default Components